/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_T_ShirtInputs */

const en_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt`)
};

const es_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camiseta`)
};

const fr_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt`)
};

const de_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt`)
};

const ja_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tシャツ`)
};

const zh_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T恤`)
};

const ar_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تي شيرت`)
};

const id_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaos`)
};

const it_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T-Shirt`)
};

const ru_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Футболка`)
};

const pt_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camiseta`)
};

const ko_val_t_shirt = /** @type {(inputs: Val_T_ShirtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`티셔츠`)
};

/**
* | output |
* | --- |
* | "T-Shirt" |
*
* @param {Val_T_ShirtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_t_shirt = /** @type {((inputs?: Val_T_ShirtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_T_ShirtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_t_shirt(inputs)
	if (locale === "es") return es_val_t_shirt(inputs)
	if (locale === "fr") return fr_val_t_shirt(inputs)
	if (locale === "de") return de_val_t_shirt(inputs)
	if (locale === "ja") return ja_val_t_shirt(inputs)
	if (locale === "zh") return zh_val_t_shirt(inputs)
	if (locale === "ar") return ar_val_t_shirt(inputs)
	if (locale === "id") return id_val_t_shirt(inputs)
	if (locale === "it") return it_val_t_shirt(inputs)
	if (locale === "ru") return ru_val_t_shirt(inputs)
	if (locale === "pt") return pt_val_t_shirt(inputs)
	return ko_val_t_shirt(inputs)
});